import { useSearchParams } from 'react-router-dom';

export type CalendarViewName = 'day' | 'week' | 'month-grid' | 'list';

const VALID_VIEWS: CalendarViewName[] = ['day', 'week', 'month-grid', 'list'];

/** URL-backed (`?view=`) Day/Week/Month/Agenda mode for the Calendar page — pairs with `CalendarViewSwitcher`. */
export function useCalendarView() {
  const [searchParams, setSearchParams] = useSearchParams();

  const viewParam = searchParams.get('view');
  const view: CalendarViewName = VALID_VIEWS.includes(viewParam as CalendarViewName)
    ? (viewParam as CalendarViewName)
    : 'month-grid';

  const setView = (next: CalendarViewName) => {
    const nextParams = new URLSearchParams(searchParams);
    if (next === 'month-grid') nextParams.delete('view');
    else nextParams.set('view', next);
    setSearchParams(nextParams, { replace: true });
  };

  return { view, setView };
}
